module.exports = __webpack_public_path__ + "static/img/solutionDetailPic3.afc6dc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic3.png
// module id = L49T
// module chunks = 1